type ButtonSize =
  | "default"
  | "xs"
  | "sm"
  | "lg"
  | "icon"
  | "icon-xs"
  | "icon-sm"
  | "icon-lg";

export const ICON_ONLY_SIZE_MAP: Partial<Record<ButtonSize, ButtonSize>> = {
  xs: "icon-xs",
  sm: "icon-sm",
  default: "icon",
  lg: "icon-lg",
};

export const SPINNER_SIZE_MAP: Record<ButtonSize, string> = {
  xs: "size-3",
  sm: "size-3.5",
  default: "size-3.5",
  lg: "size-4",
  icon: "size-3.5",
  "icon-xs": "size-3",
  "icon-sm": "size-3.5",
  "icon-lg": "size-4",
};

// Map NeetoUI tooltip `position` values to Radix side values
export const TOOLTIP_SIDE_MAP: Record<
  string,
  "top" | "right" | "bottom" | "left"
> = {
  top: "top",
  bottom: "bottom",
  left: "left",
  right: "right",
  "top-start": "top",
  "top-end": "top",
  "bottom-start": "bottom",
  "bottom-end": "bottom",
  "left-start": "left",
  "left-end": "left",
  "right-start": "right",
  "right-end": "right",
};
